import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.string.trim.js";
import { defineComponent as _defineComponent } from 'vue';
import { useShowDebugging } from '~/functions/accounts';
import { renderMarkdown } from '~/functions/markdown';
export default /*#__PURE__*/_defineComponent({
  __name: 'MetricDetails',
  props: {
    metric: {
      type: Object,
      required: true
    },
    unitName: {
      type: String,
      default: ''
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var showDebugging = useShowDebugging();
    var hasDescription = computed(function () {
      var _description, _props$metric;
      return !!String((_description = (_props$metric = props.metric) === null || _props$metric === void 0 ? void 0 : _props$metric.description) !== null && _description !== void 0 ? _description : '').trim();
    });
    return {
      __sfc: true,
      props: props,
      showDebugging: showDebugging,
      hasDescription: hasDescription,
      renderMarkdown: renderMarkdown
    };
  }
});